/**
 * @class
 */
import Base from './assetConstituent';

export default class AssetConstituent_Keyframe extends Base {
	/**
	 * @property {object}  defaults       - The default attribute values
	 * @property {number}  defaults.type  - Default type (1 = keyframe)
	 */
	get defaults() {
		return _.extend(super.defaults, {
			type: 1,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituent_Keyframe';
	}
}
